import SiPhotImg from '../assets/img/home/siliconphotonicchip.png';
import SiChipDesignImg from '../assets/img/home/siliconchipdesign.png';
import SystemDesignImg from '../assets/img/home/systemdesign.png';

import { Link } from 'react-router-dom'


function Card(){
    return (
            <section>
            <div className="container">
                <div className="row justify-content-center text-center mb-3 mb-md-5">
                <div className="col-lg-8 col-xxl-7 pt-5">
                    <span className="text-muted">Purpose</span>
                    <h2 className="display-5 fw-bold mb-3">Explore Remarkable Open-Source Tools for Chip & System Design</h2>
                    <p className="lead">
                    Browse through a curated collection of powerful open-source tools designed to boost your projects. 
                    Explore, adapt, and innovate with ease.
                    </p>
                </div>
                </div>

                <div className="row row-cols-1 row-cols-md-3 g-4">

                {/* CARD 1 */}
                <div className="col">
                    <div className="card h-100">
                    <img alt="" className="img-fluid rounded-1" src={SiChipDesignImg} />
                    <div className="card-body d-flex flex-column">
                        <h5 className="card-title text-center">CMOS/GAN Chip Design Tools</h5>
                        <p className="card-text">
                        Explore a comprehensive suite of tools tailored for CMOS and GaN chip design. From layout planning to simulation and verification, these tools streamline complex design workflows and accelerate innovation in power and analog ICs.                        </p>
                       <Link to="/tools" className="btn btn-primary w-100 btn-lg mt-auto">
                        <i className="fas fa-rocket me-2" /> Learn More
                        </Link>
                    </div>
                    <div className="card-footer text-center">
                        <small className="text-body-secondary">Last updated 3 mins ago</small>
                    </div>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="col">
                    <div className="card h-100">
                    <img alt="" className="img-fluid rounded-1" src={SiPhotImg} />
                    <div className="card-body d-flex flex-column">
                        <h5 className="card-title text-center">Photonics/MEMS Chip Design Tools</h5>
                        <p className="card-text">
                        Discover specialized tools for designing Photonic and MEMS chips—enabling precise modeling, simulation, and layout of optical and micro-electromechanical systems. Accelerate development from concept to fabrication with industry-ready workflows.                        </p>
                        <Link to="/tools" className="btn btn-primary w-100 btn-lg mt-auto">
                        <i className="fas fa-rocket me-2" /> Learn More
                        </Link>
                    </div>
                    <div className="card-footer text-center">
                        <small className="text-body-secondary">Last updated 3 mins ago</small>
                    </div>
                    </div>
                </div>

                {/* CARD 3 */}
                <div className="col">
                    <div className="card h-100">
                    <img alt="" className="img-fluid rounded-1" src={SystemDesignImg} />
                    <div className="card-body d-flex flex-column">
                        <h5 className="card-title text-center">System Design Tools</h5>
                        <p className="card-text">
                        Access a robust set of tools for system-level design, integration, and validation—spanning digital, analog, RF, and mixed-signal domains. These tools support co-simulation, hardware/software co-design, and architecture exploration to accelerate complex system development and ensure seamless interoperability across components.                        </p>
                        <Link to="/tools" className="btn btn-primary w-100 btn-lg mt-auto">
                        <i className="fas fa-rocket me-2" /> Learn More
                        </Link>
                    </div>
                    <div className="card-footer text-center">
                        <small className="text-body-secondary">Last updated 3 mins ago</small>
                    </div>
                    </div>
                </div>

                </div>
            </div>
            </section>

    )
}

export default Card